export const th = {
  // Common
  common: {
    loading: 'กำลังโหลด...',
    error: 'ข้อผิดพลาด',
    save: 'บันทึก',
    cancel: 'ยกเลิก',
    delete: 'ลบ',
    edit: 'แก้ไข',
    add: 'เพิ่ม',
    search: 'ค้นหา',
    back: 'กลับ',
    close: 'ปิด',
    confirm: 'ยืนยัน',
    yes: 'ใช่',
    no: 'ไม่',
    ok: 'ตกลง',
    submit: 'ส่ง',
    reset: 'รีเซ็ต',
    clear: 'ล้าง',
    view: 'ดู',
    details: 'รายละเอียด',
    settings: 'ตั้งค่า',
    logout: 'ออกจากระบบ',
    login: 'เข้าสู่ระบบ',
    signup: 'สมัครสมาชิก',
    profile: 'โปรไฟล์',
    collection: 'คอลเลกชัน',
    insights: 'ข้อมูลเชิงลึก',
    overview: 'ภาพรวม',
    categories: 'หมวดหมู่',
    preorders: 'สั่งจองล่วงหน้า',
    recent: 'ล่าสุด',
    total: 'รวม',
    average: 'เฉลี่ย',
    price: 'ราคา',
    quantity: 'จำนวน',
    brand: 'แบรนด์',
    series: 'ซีรีส์',
    type: 'ประเภท',
    scale: 'สเกล',
    source: 'แหล่งที่มา',
    date: 'วันที่',
    status: 'สถานะ',
    value: 'มูลค่า',
    items: 'รายการ',
    owned: 'เป็นเจ้าของ',
    preorder: 'สั่งจองล่วงหน้า',
    created: 'สร้างเมื่อ',
    updated: 'อัปเดตเมื่อ',
    name: 'ชื่อ',
    code: 'รหัส',
    description: 'คำอธิบาย',
    image: 'รูปภาพ',
    currency: 'สกุลเงิน',
    language: 'ภาษา',
    preferences: 'การตั้งค่า',
    clone: 'คัดลอก',
    cloneSuccess: 'คัดลอกของเล่นสำเร็จแล้ว',
    cloneError: 'ไม่สามารถคัดลอกของเล่นได้',
    backToCollection: 'กลับไปยังคอลเลกชัน'
  },

  // Navigation
  nav: {
    home: 'หน้าแรก',
    collection: 'คอลเลกชัน',
    insights: 'ข้อมูลเชิงลึก',
    wishlist: 'รายการที่ต้องการ',
    settings: 'ตั้งค่า',
    profile: 'โปรไฟล์',
    logout: 'ออกจากระบบ',
    language: 'ภาษา',
    export: 'ส่งออก'
  },

  // Landing Page
  landing: {
    title: 'ToyPort',
    subtitle: 'เครื่องมือจัดการคอลเลกชันของเล่นขั้นสุดยอด',
    description: 'จัดระเบียบ ติดตาม และจัดการคอลเลกชันของเล่นและโมเดลของคุณได้อย่างง่ายดาย สร้างโดยนักสะสม เพื่อนักสะสม',
    getStarted: 'เริ่มต้น',
    signUp: 'สมัครสมาชิก',
    goToCollection: 'ไปที่คอลเลกชัน',
    sampleCollection: 'คอลเลกชันตัวอย่าง',
    features: {
      title: 'คุณสมบัติที่ทรงพลัง',
      subtitle: 'ทุกสิ่งที่คุณต้องการเพื่อจัดการคอลเลกชันของคุณ',
      completeManagement: {
        title: 'การจัดการที่สมบูรณ์',
        description: 'เพิ่ม แก้ไข และจัดระเบียบของเล่นของคุณด้วยข้อมูลและหมวดหมู่ที่ละเอียด'
      },
      smartSearch: {
        title: 'การค้นหาอัจฉริยะ',
        description: 'ค้นหาของเล่นของคุณได้อย่างรวดเร็วด้วยความสามารถในการค้นหาและกรองที่ทรงพลัง'
      },
      multiCurrency: {
        title: 'หลายสกุลเงิน',
        description: 'ติดตามราคาในสกุลเงินท้องถิ่นของคุณด้วยการสนับสนุนการแปลงอัตโนมัติ'
      },
      preorderTracking: {
        title: 'การติดตามการสั่งจอง',
        description: 'ติดตามการสั่งจองและวันที่คาดว่าจะวางจำหน่าย'
      },
      cloudSync: {
        title: 'การซิงค์คลาวด์',
        description: 'คอลเลกชันของคุณจะซิงค์อัตโนมัติในอุปกรณ์ทั้งหมดของคุณ'
      },
      secure: {
        title: 'ปลอดภัยและเป็นส่วนตัว',
        description: 'ข้อมูลของคุณถูกเข้ารหัสและเป็นส่วนตัว เฉพาะคุณเท่านั้นที่สามารถเข้าถึงคอลเลกชันของคุณได้'
      }
    },
    howItWorks: {
      title: 'วิธีการทำงาน',
      subtitle: 'เริ่มต้นในไม่กี่นาทีด้วยกระบวนการ 4 ขั้นตอนที่เรียบง่ายของเรา',
      signUp: {
        title: 'สมัครสมาชิก',
        description: 'สร้างบัญชีฟรีของคุณในไม่กี่วินาทีด้วยอีเมลหรือการเข้าสู่ระบบทางสังคม'
      },
      addToys: {
        title: 'เพิ่มของเล่นของคุณ',
        description: 'เพิ่มคอลเลกชันที่มีอยู่ของคุณด้วยอินเทอร์เฟซที่ใช้งานง่าย'
      },
      organize: {
        title: 'จัดระเบียบ',
        description: 'จัดหมวดหมู่และแท็กของเล่นของคุณเพื่อการจัดการที่ง่าย'
      },
      monitor: {
        title: 'ติดตามและตรวจสอบ',
        description: 'ติดตามมูลค่าคอลเลกชันของคุณและรับข้อมูลเชิงลึกเกี่ยวกับของเล่นของคุณ'
      }
    },
    benefits: {
      title: 'ทำไมต้องเลือก ToyPort?',
      subtitle: 'เข้าร่วมกับนักสะสมหลายพันคนที่ไว้วางใจ ToyPort ในการจัดการคอลเลกชันของพวกเขา',
      neverLose: 'ไม่เคยสูญเสียการติดตามคอลเลกชันของคุณอีกครั้ง',
      trackValue: 'ติดตามมูลค่ารวมของคอลเลกชันของคุณ',
      planPurchases: 'วางแผนการซื้อในอนาคตด้วยการติดตามราคา',
      shareCollection: 'แบ่งปันคอลเลกชันของคุณกับเพื่อนและครอบครัว',
      mobileFriendly: 'เข้าถึงคอลเลกชันของคุณจากอุปกรณ์ใดก็ได้',
      freeToUse: 'ใช้งานฟรีโดยไม่มีค่าใช้จ่ายที่ซ่อนอยู่'
    },
    collectorTypes: {
      title: 'เหมาะสำหรับนักสะสมทุกประเภท',
      description: 'ไม่ว่าคุณจะสะสมกันพลา โมเดลสเกล ฟิกเกอร์แอคชัน หรือของเล่นอื่นๆ ToyPort มีให้คุณครอบคลุม',
      startCollection: 'เริ่มคอลเลกชันของคุณ'
    },
    cta: {
      title: 'พร้อมที่จะจัดระเบียบคอลเลกชันของคุณแล้วหรือยัง?',
      subtitle: 'เข้าร่วมกับนักสะสมหลายพันคนที่จัดระเบียบคอลเลกชันของพวกเขาด้วย ToyPort แล้ว',
      createAccount: 'สร้างบัญชีฟรี'
    }
  },

  // Collection
  collection: {
    title: 'คอลเลกชันของเล่นของฉัน',
    addNewToy: 'เพิ่มของเล่นใหม่',
    searchPlaceholder: 'ค้นหาตามชื่อ รหัส แบรนด์ หรือซีรีส์...',
    noToys: 'ยังไม่มีของเล่นในคอลเลกชันของคุณ',
    noSearchResults: 'ไม่พบของเล่นที่ตรงกับการค้นหาของคุณ',
    addFirstToy: 'เพิ่มของเล่นชิ้นแรกของคุณ',
    showingResults: 'แสดง {count} จาก {total} ชิ้น',
    endOfResults: 'คุณได้ถึงจุดสิ้นสุดของคอลเลกชันแล้ว',
    summary: {
      title: 'ติดตามและจัดระเบียบคอลเลกชันของเล่นอันมีค่าของคุณ',
      totalToys: 'ของเล่นทั้งหมด',
      foundToys: 'ของเล่นที่พบ',
      totalValue: 'มูลค่ารวม',
      averagePrice: 'ราคาเฉลี่ย',
      totalQuantity: 'จำนวนรวม'
    },
    share: {
      description: 'Share a view-only link of your collection with friends or buyers.',
      copyLink: 'Copy public link',
      preview: 'Preview public page',
      copied: 'Public link copied to your clipboard.',
      copyFailed: 'Clipboard access is blocked. Copy this link manually: {url}',
      publishError: 'We could not refresh your public collection. Try again in a moment.',
      nothingToShare: 'Add at least one toy before sharing your collection.',
      publishing: 'Updating link…'
    },
    export: {
      title: 'Export Your Collection',
      subtitle: 'Download a backup of your toys for reports, inventory, or migration.',
      authRequired: 'You need to be signed in to export your collection.',
      loadError: 'We could not load your collection for export. Please try again.',
      empty: 'No toys to export yet. Add items to your collection first.',
      actionsTitle: 'Download files',
      actionsSubtitle: '{count, plural, one {1 item ready} other {{count} items ready}}',
      downloadCsv: 'Download CSV',
      downloadJson: 'Download JSON',
      fileHint: 'CSV works best in spreadsheets. JSON keeps all fields for data migration.',
      previewTitle: 'Preview (first {count} items)',
      previewSubtitle: '{total} total items · Prices in {currency}',
      previewFooter: '{remaining} more items not shown in preview.',
      headers: {
        name: 'Name',
        brand: 'Brand',
        series: 'Series',
        type: 'Type',
        scale: 'Scale',
        code: 'Code',
        quantity: 'Quantity',
        price: 'Price',
        priceCurrency: 'Price Currency',
        preorderPrice: 'Preorder Price',
        preorderPriceCurrency: 'Preorder Currency',
        source: 'Source',
        note: 'Notes',
        createdDate: 'Created Date'
      }
    }
  },

  // Toy Detail
  toyDetail: {
    newToy: 'เพิ่มของเล่นใหม่',
    editToy: 'แก้ไขของเล่น',
    name: 'ชื่อ',
    code: 'รหัส',
    codePlaceholder: 'รหัสสินค้า (ไม่บังคับ)',
    brand: 'แบรนด์',
    series: 'ซีรีส์',
    type: 'ประเภท',
    scale: 'สเกล',
    price: 'ราคา',
    preorderPrice: 'ราคาสั่งจองล่วงหน้า',
    quantity: 'จำนวน',
    source: 'แหล่งที่มา',
    imageUrl: 'URL รูปภาพ',
    createdDate: 'วันที่สร้าง',
    notes: 'บันทึก',
    save: 'บันทึกของเล่น',
    cancel: 'ยกเลิก',
    delete: 'ลบของเล่น',
    deleteConfirm: 'คุณแน่ใจหรือไม่ที่จะลบของเล่นนี้?',
    deleteConfirmDescription: 'การดำเนินการนี้ไม่สามารถยกเลิกได้',
    imagePlaceholder: 'ไม่มีรูปภาพ'
  },

  // Insights
  insights: {
    title: 'ข้อมูลเชิงลึกของคอลเลกชัน',
    subtitle: 'การวิเคราะห์และข้อมูลเชิงลึกแบบละเอียดเกี่ยวกับคอลเลกชันของเล่นของคุณ',
    overview: {
      title: 'ภาพรวม',
      collectionStatus: 'สถานะคอลเลกชัน',
      ownedItems: 'รายการที่เป็นเจ้าของ',
      preorderItems: 'รายการสั่งจองล่วงหน้า',
      valueBreakdown: 'การแบ่งมูลค่า',
      ownedValue: 'มูลค่าที่เป็นเจ้าของ',
      preorderValue: 'มูลค่าสั่งจองล่วงหน้า',
      mostValuableItems: 'รายการที่มีมูลค่าสูงสุด'
    },
    categories: {
      title: 'หมวดหมู่',
      topBrands: 'แบรนด์ยอดนิยม',
      topSeries: 'ซีรีส์ยอดนิยม',
      topTypes: 'ประเภทยอดนิยม',
      topScales: 'สเกลยอดนิยม',
      topSources: 'แหล่งที่มายอดนิยม'
    },
    preorders: {
      title: 'สั่งจองล่วงหน้า',
      preorderSummary: 'สรุปการสั่งจองล่วงหน้า',
      items: 'รายการ',
      totalValue: 'มูลค่ารวม'
    },
    recent: {
      title: 'ล่าสุด',
      recentAdditions: 'รายการที่เพิ่มล่าสุด'
    },
    stats: {
      totalItems: 'รายการทั้งหมด',
      totalValue: 'มูลค่ารวม',
      totalQuantity: 'จำนวนรวม',
      averagePrice: 'ราคาเฉลี่ย'
    }
  },

  // Settings
  settings: {
    title: 'ตั้งค่าผู้ใช้',
    currency: 'สกุลเงิน',
    language: 'ภาษา',
    saveSettings: 'บันทึกการตั้งค่า',
    settingsSaved: 'บันทึกการตั้งค่าสำเร็จ!',
    settingsError: 'ไม่สามารถบันทึกการตั้งค่าได้',
    currencyDescription: 'ตั้งค่าสกุลเงินที่คุณต้องการสำหรับแสดงราคาในแอปพลิเคชัน ราคาทั้งหมดจะถูกแปลงเป็นสกุลเงินที่คุณเลือก',
    languageDescription: 'เลือกภาษาที่คุณต้องการสำหรับอินเทอร์เฟซแอปพลิเคชัน ภาษาจะถูกใช้ทันที',
    preferences: 'การตั้งค่า'
  },

  // Custom Data
  customData: {
    addNew: 'เพิ่ม{type}ใหม่',
    add: 'เพิ่ม',
    adding: 'กำลังเพิ่ม...',
    valueRequired: 'ต้องระบุค่า',
    userNotAuthenticated: 'ผู้ใช้ไม่ได้รับการยืนยันตัวตน',
    addError: 'ไม่สามารถเพิ่มข้อมูลที่กำหนดเองได้',
    description: '{type}นี้จะถูกเพิ่มในรายการส่วนตัวของคุณและจะแสดงเฉพาะคุณเท่านั้น',
    enterValue: 'ป้อนชื่อ{type}',
    tip: 'หา{type}ของคุณไม่เจอ? พิมพ์และเลือกหรือแท็บออกเพื่อเพิ่มในรายการส่วนตัวของคุณ',
    standard: 'มาตรฐาน',
    manageTitle: 'จัดการข้อมูลที่กำหนดเอง',
    manageDescription: 'จัดการแบรนด์ ชุด ชนิด สเกล และแหล่งที่มาส่วนตัวของคุณ สิ่งเหล่านี้จะแสดงเฉพาะคุณเท่านั้น',
    manageSubtitle: 'ข้อมูลหลักส่วนตัว',
    manageSubDescription: 'เพิ่มและจัดการแบรนด์ ชุด ชนิด สเกล และแหล่งที่มาของคุณเองที่ไม่อยู่ในรายการมาตรฐาน',
    manageButton: 'จัดการข้อมูลที่กำหนดเอง',
    loadError: 'ไม่สามารถโหลดข้อมูลที่กำหนดเองได้',
    deleteError: 'ไม่สามารถลบข้อมูลที่กำหนดเองได้',
    delete: 'ลบ',
    items: 'รายการ',
    noItems: 'ยังไม่มีรายการ{type}ที่กำหนดเอง',
    customItem: 'รายการที่กำหนดเอง'
  },

  // Auth
  auth: {
    login: {
      title: 'เข้าสู่ระบบ ToyPort',
      email: 'อีเมล',
      password: 'รหัสผ่าน',
      signIn: 'เข้าสู่ระบบ',
      signInWithGoogle: 'เข้าสู่ระบบด้วย Google',
      noAccount: 'ยังไม่มีบัญชี?',
      signUp: 'สมัครสมาชิก',
      forgotPassword: 'ลืมรหัสผ่าน?',
      loginError: 'ไม่สามารถเข้าสู่ระบบได้'
    },
    signup: {
      title: 'สร้างบัญชีของคุณ',
      displayName: 'ชื่อที่แสดง',
      email: 'อีเมล',
      password: 'รหัสผ่าน',
      confirmPassword: 'ยืนยันรหัสผ่าน',
      signUp: 'สมัครสมาชิก',
      signUpWithGoogle: 'สมัครสมาชิกด้วย Google',
      haveAccount: 'มีบัญชีอยู่แล้ว?',
      signIn: 'เข้าสู่ระบบ',
      signupError: 'ไม่สามารถสร้างบัญชีได้',
      passwordMismatch: 'รหัสผ่านไม่ตรงกัน'
    }
  },

  // Languages
  languages: {
    en: 'English',
    th: 'ไทย',
    ja: '日本語',
    zh: '中文'
  },

  // Wishlist
  wishlist: {
    title: 'รายการที่ต้องการ',
    subtitle: 'ติดตามรายการที่คุณต้องการเพิ่มในคอลเลกชัน',
    addNewWish: 'เพิ่มรายการที่ต้องการ',
    addFirstWish: 'เพิ่มรายการที่ต้องการแรกของคุณ',
    searchPlaceholder: 'ค้นหารายการในรายการที่ต้องการ...',
    noWishItems: 'ยังไม่มีรายการในรายการที่ต้องการของคุณ',
    noSearchResults: 'ไม่พบรายการในรายการที่ต้องการที่ตรงกับการค้นหาของคุณ',
    showingResults: 'แสดง {count} จาก {total} รายการ',
    convertToToy: 'แปลงเป็นของเล่น',
    convert: 'ใช่ ฉันได้มาแล้ว!',
    converting: 'กำลังแปลง...',
    convertConfirm: 'คุณได้มาแล้วหรือยัง?',
    convertConfirmDescription: 'นี่จะย้ายรายการนี้จากรายการที่ต้องการไปยังคอลเลกชันของคุณ คุณสามารถเพิ่มข้อมูลจำนวนและแหล่งที่มาได้หลังจากนั้น',
    deleteConfirm: 'ลบรายการที่ต้องการ?',
    deleteConfirmDescription: 'นี่จะลบรายการที่ต้องการนี้อย่างถาวร การดำเนินการนี้ไม่สามารถยกเลิกได้',
    // New celebratory conversion messages
    congratulations: '🎉 ยินดีด้วย! 🎉',
    finallyGotIt: 'ในที่สุดก็ได้มาแล้วสินะ!',
    thatsAwesome: 'สุดยอดเลย! 🎊 ตอนนี้ถึงเวลาแล้วที่จะย้ายของสวยๆ ชิ้นนี้จากรายการที่อยากได้ไปเป็นของในคอลเลกชันแล้ว คุณจะเพิ่มข้อมูลอื่นๆ เช่นจำนวนและที่ซื้อมาได้ด้วย',
    readyToCelebrate: 'พร้อมจะเฉลิมฉลองการได้ของใหม่แล้วหรือยัง?',
    maybeLater: 'ไว้ก่อนนะ',
    yesAddToCollection: '🎉 ใช่เลย! เพิ่มในคอลเลกชัน!',
    addingToCollection: 'กำลังเพิ่มในคอลเลกชัน...'
  },

  publicCollection: {
    title: 'Shared Collection',
    subtitle: 'Curated by collector {collectorId}',
    backToLanding: 'Back to ToyPort',
    viewOnlyNotice: 'This page is read-only. Prices shown in {currency}.',
    emptyTitle: 'No items to show yet',
    emptyDescription: 'The owner has not added any items or keeps them private.',
    invalidLink: 'This public collection link is invalid.',
    loadError: 'We could not load this collection right now. Please try again later.',
    notShared: 'This collector has not published a public snapshot yet.',
    untitledToy: 'Untitled Toy',
    unknownBrand: 'Unknown brand'
  },

  // Currencies
  currencies: {
    USD: 'ดอลลาร์สหรัฐ',
    THB: 'บาทไทย',
    JPY: 'เยนญี่ปุ่น',
    CNY: 'หยวนจีน'
  }
}; 
